import { FieldSettings, FieldType, TableExtension } from './types';

export const settingsForType = (type: FieldType): FieldSettings => {
  if (type === 'text') return { max_length: 255 };
  if (type === 'long_text') return { max_length: 65535 };
  if (type === 'decimal') return { precision: 18, scale: 2 };
  if (type === 'select' || type === 'multi_select') return { options: [] };
  return {};
};

export const formatDefaultValue = (value: TableExtension['default_value']): string => {
  if (value === null) return '';
  if (Array.isArray(value)) return value.join('\n');
  return String(value);
};

export const parseDefaultValue = (type: FieldType, enabled: boolean, text: string) => {
  if (!enabled) return null;
  if (type === 'boolean') return text === 'true';
  if (type === 'multi_select') return text.split('\n').map((value) => value.trim()).filter(Boolean);
  if (type === 'datetime') {
    const date = text.replace('T', ' ');
    return date.length === 16 ? `${date}:00` : date;
  }
  return text;
};
